import "./styles.scss";
import { observer } from "mobx-react-lite";
import reconnectingAnimationSvg from "../../assets/images/wifiAnimation.svg";
import { mainStore } from "../../mainStore";
import { keyboardStore } from "../../mainStore/keyBoardStore";

export const ReconnectingModal = observer(() => {
  if (!mainStore.isShowReconnectingModal) return;

  keyboardStore.close();
  return (
    <>
      <div className={"reconnecting-view-container"}>
        <div className={"svg-wrapper"}>
          <img src={reconnectingAnimationSvg} alt="" />
        </div>
      </div>
    </>
  );
});
